import BannerWeb from "./web";
import { BannerBlockProps } from "./types";

export function BannerWebEditor(props: BannerBlockProps) {
  return <BannerWeb {...props} />;
}
